import { observable, decorate, makeObservable } from "mobx";

export default class PlannedProgressEntry {
  project;
  taskOrSummary;
  period = "";
  expectedProgress = "";
  expectedCost = "";
  periodWeight = "";
  nonWorkingPeriod = false;

  constructor(
    project,
    taskOrSummary,
    period,
    expectedProgress,
    expectedCost,
    periodWeight,
    nonWorkingPeriod
  ) {
    this.taskOrSummary = taskOrSummary;
    this.project = project;
    this.period = period;
    this.expectedProgress = expectedProgress;
    this.expectedCost = expectedCost;
    this.periodWeight = periodWeight;
    this.nonWorkingPeriod = nonWorkingPeriod;

    makeObservable(this, {
      period: observable,
      expectedProgress: observable,
      expectedCost: observable,
      periodWeight: observable,
      nonWorkingPeriod: observable,
    })
  }

  toJS() {
    return {
      period: this.period,
      expectedProgress: +this.expectedProgress,
      expectedCost: +this.expectedCost,
      periodWeight: +this.periodWeight,
      nonWorkingPeriod: this.nonWorkingPeriod == null? false: this.nonWorkingPeriod,
    };
  }

  static fromJS(store, object) {
    const entry = new PlannedProgressEntry();
    if (object != null) {
      entry.period = object.period;
      entry.expectedProgress = object.expectedProgress;
      entry.expectedCost = object.expectedCost;
      entry.nonWorkingPeriod = object.nonWorkingPeriod;
      entry.periodWeight = object.periodWeight;
      entry.project = store;
    }
    return entry;
  }
}
